import React from 'react';
import GLOBE from 'assets/img/globe.svg';
import STAR from 'assets/img/star.svg';
import CIRCLE from 'assets/img/circle.svg';
import TRUCK from 'assets/img/truck.svg';
import cx from 'classnames';
import './style.scss';

const Option = props => (
  <div
    className={cx('optionWrapper', {
      active: props.active,
    })}
    onClick={props.onClick}
  >
    <div className="optionHeader">
      <img src={props.iconSrc} alt="" style={{ width: '30px' }} />
      <h3>{props.reasonHeader.toUpperCase()}</h3>
    </div>
    <div className="optionContent">
      <p>{props.reasonText}</p>
      <p>Suggested configuration</p>
      <p>{props.suggestion}</p>
    </div>
  </div>
);

const Why = props => (
  <div className="modalContent">
    <h1>Why 10% of the addresses do not meet your solution criteria?</h1>
    <Option
      active={props.activeWhyIndex === 0}
      onClick={() => props.handleSelectOption(0)}
      reasonHeader="providers"
      reasonText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro veniam iusto ducimus hic quaerat animi deserunt perferendis optio at quis numquam aliquid nobis, distinctio facere tempore consequuntur? Ipsam, repudiandae quisquam."
      suggestion="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      iconSrc={GLOBE}
    />
    <Option
      active={props.activeWhyIndex === 1}
      onClick={() => props.handleSelectOption(1)}
      reasonHeader="providers"
      reasonText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro veniam iusto ducimus hic quaerat animi deserunt perferendis optio at quis numquam aliquid nobis, distinctio facere tempore consequuntur? Ipsam, repudiandae quisquam."
      suggestion="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      iconSrc={STAR}
    />
    <Option
      active={props.activeWhyIndex === 2}
      onClick={() => props.handleSelectOption(2)}
      reasonHeader="providers"
      reasonText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro veniam iusto ducimus hic quaerat animi deserunt perferendis optio at quis numquam aliquid nobis, distinctio facere tempore consequuntur? Ipsam, repudiandae quisquam."
      suggestion="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      iconSrc={CIRCLE}
    />
    <Option
      active={props.activeWhyIndex === 3}
      onClick={() => props.handleSelectOption(3)}
      reasonHeader="providers"
      reasonText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro veniam iusto ducimus hic quaerat animi deserunt perferendis optio at quis numquam aliquid nobis, distinctio facere tempore consequuntur? Ipsam, repudiandae quisquam."
      suggestion="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      iconSrc={TRUCK}
    />

    <button onClick={props.submit} type="button" disabled={props.activeWhyIndex === null} className={cx('done', { done_disabled: props.activeWhyIndex === null })}>Apply Suggested Configuration</button>
    <button onClick={props.cancel} type="button" className="cancel">Cancel</button>
  </div>
);

export { Why };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/Why.js